import { MROIColumnSelector } from "@/pages/channel-roi/constants/types";

export const isSpendRevenueROI = (columnView: MROIColumnSelector) =>
  columnView === MROIColumnSelector.SPEND_VS_REVENUE_AMOUNT ||
  columnView === MROIColumnSelector.SPEND_VS_REVENUE_PERCENTAGE ||
  columnView === MROIColumnSelector.ROI_PERCENTAGE;

export const isShareOfEffect = (columnView: MROIColumnSelector) =>
  columnView === MROIColumnSelector.SHARE_OF_EFFECT_AMOUNT ||
  columnView === MROIColumnSelector.SHARE_OF_EFFECT_PERCENTAGE;

export const isMarketingReturn = (columnView: MROIColumnSelector) =>
  columnView === MROIColumnSelector.MARKETING_RETURN_AMOUNT ||
  columnView === MROIColumnSelector.MARKETING_RETURN_PERCENTAGE;

const shareOfEffectPercentageTooltipText = (funnelStage: string) =>
  `This number represents the share of ${funnelStage} media revenue for this product generated by this channel over the time period`;

const shareOfEffectAmountTooltipText = (funnelStage: string) =>
  `This number represents the incremental revenue generated for this product by this channel’s ${funnelStage} marketing activities over the time period`;

export const getShareOfEffectTooltipText = (funnelStage: string, isPercentage: boolean) =>
  isPercentage
    ? shareOfEffectPercentageTooltipText(funnelStage)
    : shareOfEffectAmountTooltipText(funnelStage);
